/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {generateCronSchedule} from '../api'

export const useMutationGenerateCronSchedule = createReactQueryMutationHook('generateCronSchedule', generateCronSchedule)
